export const TRANSLATION_GROUP_MIRRORS_EDIT = Symbol('admin.mirrors-list.edit');

export const MIRRORS_LIST_EDIT_JS_ROUTE_NAME = Symbol('admin.mirrors-list.edit-js');
export const MIRRORS_LIST_EDIT_NO_JS_ROUTE_NAME = Symbol('admin.mirrors-list.edit-no-js');

export const MIRRORS_LIST_EDIT_QUERY_KEY = 'admin.mirrors-list-edit';
export const MIRRORS_LIST_EDIT_API_URL = 'admin/mirrors/:id/edit';

export const MIRRORS_LIST_EDIT_MUTATION_KEY = 'admin.mirrors-list-mutation';
export const MIRRORS_LIST_EDIT_MUTATION_API_URL = 'admin/mirrors/:id';
